export const CHART_BASE_DIMENSION = 'snapshot_dttm' as const;

export const SNAPSHOT_DATE_FILTER_DIMENSION = 'snapshot_dttm' as const;
/** The cohort date is published as `cohort_dt` and maps to INSTALL_DT in the DWH. */
export const COHORT_DATE_FILTER_DIMENSION = 'cohort_dt' as const;

// Gated per client in the catalog; each falls back to meta.defaultAxis if missing.
export const DEFAULT_SPLIT_DIMENSION = 'cohort_ww' as const;
export const DEFAULT_PRIMARY_METRIC =
  'p_revenue_net_base_currency_365' as const;
